// Container API
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

/*
* belongs specifically to the Container API
* */
export enum ContainerQueryNames {
    all = 'all',
    excluded = 'excluded',
    operational = 'operational',
    longtermleaseavailable = 'longtermleaseavailable'
}

type ContainerRequests = {
    name: string,
    [RequestKeys.getContainerBySerialNumber]: RequestConfigFunction<{ serialNumber: string }>,
    update: RequestConfigFunction<{ serialNumber: string }>,
    statusChange: RequestConfigFunction<{ serialNumber: string }>,
    batchCreate: RequestConfigFunction<undefined>,
    getLastGeolocation: RequestConfigFunction<{ serialNumber: string }>,
    getDamageByContainer:
        RequestConfigFunction<{ params: Record<string, any>, serialNumber: string }>,
    damageByContainerCountRequest: (serialNumber: string) => {
        customUrl: string,
    },
    getAllowedContainerStatusTransitions: RequestConfigFunction<{ serialNumber: string }>,
    getSensorChecks: RequestConfigFunction<{ serialNumber: string, params: Record<string, any> }>,
    GetAvailableContainers: RequestConfigFunction<undefined>,
    wrongPairings: RequestConfigFunction<undefined>,
    [RequestKeys.getLoggerContainerInformation]:
        RequestConfigFunction<{ serialNumber: string, params?: Record<string, any> }>,
    filterRequest: RequestConfigFunction<Record<string, any> & { queryName: ContainerQueryNames }>,
}

const containerRequests: ContainerRequests = {
    name: 'Container',
    [RequestKeys.getContainerBySerialNumber]: ({
        serialNumber,
    }) => {
        return {
            url: `container?serialNumber=${serialNumber}`,
            method: 'GET',
        }
    },
    update: ({
        serialNumber,
    }) => {
        return {
            url: `container/${serialNumber}/data`,
            method: 'PATCH',
        }
    },
    statusChange: ({
        serialNumber,
    }) => {
        return {
            method: 'PATCH',
            url: `container/${serialNumber}/status-change`,
        }
    },
    batchCreate: () => {
        return {
            method: 'POST',
            url: 'container/batch-creation',
        }
    },
    getLastGeolocation: ({
        serialNumber,
    }) => {
        return {
            method: 'GET',
            url: `container/${serialNumber}/last-geolocation`,
        }
    },
    getDamageByContainer: ({
        params,
        serialNumber,
    }) => {
        return {
            url: `container/${serialNumber}/damage/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    damageByContainerCountRequest: (serialNumber) => {
        return {
            customUrl: `container/${serialNumber}/damage/filter-request/all`,
        }
    },
    getAllowedContainerStatusTransitions: ({
        serialNumber,
    }) => {
        return {
            url: `container/${serialNumber}/status-transition/allowed`,
            method: 'GET',
        }
    },
    filterRequest: ({
        queryName,
        ...params
    }) => {
        return {
            url: `container/filter-request/${queryName}`,
            method: 'POST',
            ...params,
        }
    },
    GetAvailableContainers: () => {
        return {
            url: 'container/filter-request/longtermleaseavailable',
            method: 'POST',
        }
    },
    wrongPairings: () => {
        return {
            url: 'container/filter-request/wrongpairings',
            method: 'POST',
        }
    },
    getSensorChecks: ({
        serialNumber,
        params,
    }) => {
        return {
            url: `sensordatacheckreport/${serialNumber}/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    [RequestKeys.getLoggerContainerInformation]: ({
        serialNumber,
        params,
    }) => {
        const newParams = {
            ...params,
            sort: params?.sort || {
                direction: 'desc',
                field: 'exchangeTimestamp',
            },
            rows: params?.rows || 200,
        }

        return {
            url: `container/${serialNumber}/logger-history/filter-request/all`,
            method: 'POST',
            ...newParams,
        }
    },
}

export default containerRequests
